/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import ICSelect from "../../components/form/selectInput";
import Label from "../../components/label";
import ICCheckbox from "../../components/form/checkbox";
import { useFormik } from "formik";
import * as Yup from "yup";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const PaymentSummaryModal = props => {

  let latestYear = new Date().getFullYear();
  let rangeyear = [];
  for (var i = 2018; i <= latestYear; i++) {
    rangeyear.push({
      _id: i.toString(),
      val: i.toString()
    });
  }

  const [totalYears, setTotalYears] = useState(rangeyear);
  // setTotalYears(rangeyear);

  const formik = useFormik({
    initialValues: {
      month: "Select Month",
      year: "Select Year",
      csv: true,
      pdf: false,
      which: "payment_summary"
    },
    validationSchema: Yup.object({
      month: Yup.string()
        .notOneOf(["Select Month"])
        .required("Please select the Month"),
      year: Yup.string()
        .notOneOf(["Select Year"])
        .required("Please select the Year"),
    }),
    onSubmit: values => {
      if(formik.values.csv || formik.values.pdf)
        props.onFormSubmit(values);
    }
  });

  return (
    <Modal
      isOpen={props.openModal}
      toggle={props.cancelEvent}
      className={"custom-modal-container " + props.className}
    >
      <form onSubmit={formik.handleSubmit}>
        <ModalHeader className="text-center" toggle={props.cancelEvent}>
          {props.title}
        </ModalHeader>
        <ModalBody className="text-left">
          <ICSelect
            label=""
            placeholder="Select Month"
            id="month"
            items={[
              { _id: "1", val: "January" },
              { _id: "2", val: "February" },
              { _id: "3", val: "March" },
              { _id: "4", val: "April" },
              { _id: "5", val: "May" },
              { _id: "6", val: "June" },
              { _id: "7", val: "July" },
              { _id: "8", val: "August" },
              { _id: "9", val: "September" },
              { _id: "10", val: "October" },
              { _id: "11", val: "November" },
              { _id: "12", val: "December" }
            ]}
            useId="_id"
            useValue="val"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.month}
            // handleChange={val => (formik.values.month = val)}
            handleChange={val => {
              formik.values.month = val;
              formik.setFieldValue("month", val);
              formik.handleChange("month");
            }}
            error={formik.touched.month && formik.errors.month ? true : false}
            helperText={
              formik.touched.month && formik.errors.month
                ? formik.errors.month
                : ""
            }
          />
          {formik.errors.month && formik.touched.month ? (
            <Label title="Please select month" className="small error" />
          ) : (
            ""
          )}

          <ICSelect
            label=""
            placeholder="Select Year"
            id="year"
            className="mt-4"
            // items={[
            //   { _id: "1", val: "2018" },
            //   { _id: "2", val: "2019" },
            //   { _id: "3", val: "2020" }
            // ]}
            items={totalYears}
            useId="_id"
            useValue="val"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.year}
            // handleChange={val => (formik.values.year = val)}
            handleChange={val => {
              formik.values.year = val;
              formik.setFieldValue("year", val);
              formik.handleChange("year");
            }}
            error={formik.touched.year && formik.errors.year ? true : false}
            helperText={
              formik.touched.year && formik.errors.year
                ? formik.errors.year
                : ""
            }
          />
          {formik.errors.year && formik.touched.year ? (
            <Label title="Please select year" className="small error" />
          ) : (
            ""
          )}

          <div className="row mt-3">
            <RadioGroup
              row
              aria-label="which"
              name="which"
              id="which"
              // defaultValue={value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.which}
            >
              <FormControlLabel
                className="w-auto p-0 m-0 ml-1"
                value="payment_summary"
                control={<Radio color="primary" />}
                label="Payment Summaries"
              />
              <FormControlLabel
                className="w-auto p-0 m-0 ml-3"
                value="tax_invoices"
                control={<Radio color="primary" />}
                label="Tax Invoices"
              />
            </RadioGroup>
          </div>

          <div className="row mt-3">
            <div className="col-sm-4 custom-chk-lbl">
              <Label
                title="CSV"
                required={true}
                className="gray small float-left custom-label-width"
              />
              <ICCheckbox
                name="csv"
                id="csv"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.csv}
                inputProps={{ "aria-label": "" }}
                label=""
                className="ml-3"
              />
            </div>

            <div className="col-sm-4 custom-chk-lbl">
              <Label
                title="PDF"
                required={true}
                className="gray small float-left custom-label-width"
              />
              <ICCheckbox
                name="pdf"
                id="pdf"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.pdf}
                inputProps={{ "aria-label": "" }}
                label=""
                className="ml-3"
              />
            </div>
            <div className="col-sm-12">
              {!formik.values.csv && !formik.values.pdf ? (
                <Label
                  title="Please select CSV or PDF"
                  className="small error"
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" className="insta-button-primary">
            {props.okayText}
          </Button>
          <Button className="insta-button-primary" onClick={props.cancelEvent}>
            {props.cancelText}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default PaymentSummaryModal;

PaymentSummaryModal.defaultProps = {
  okayText: "OKAY",
  cancelText: "CANCEL",
  modalBodyContent: "",
  openModal: false,
  className: "",
  useOneButton: false
};

PaymentSummaryModal.propTypes = {
  okayText: PropTypes.string,
  cancelText: PropTypes.string,
  modalBodyContent: PropTypes.string,
  cancelEvent: PropTypes.func,
  openModal: PropTypes.bool,
  className: PropTypes.string,
  useOneButton: PropTypes.bool,
  onFormSubmit: PropTypes.func
};
